import { Meal } from '@akin-home/meals';
import { useGetRecipe } from '@akin-home/recipes/react';
import { Text } from '@akin-home/text/native';
import { format } from 'date-fns';
import styled from 'styled-components/native';
import useRecordImage from '../../images/hooks/useRecordImage';

interface Props {
  meal: Meal;
}

const edits = {
  resize: {
    width: 220,
    height: 220,
    fit: 'cover',
  },
};

export const DashboardMealItem = (props: Props) => {
  const { meal } = props;
  const recipe_id = meal.recipes?.[0]?.id;

  const { data: record } = useGetRecipe({ id: recipe_id });

  const { source } = useRecordImage({
    record,
    edits,
  });

  return (
    <Container>
      <Image source={source} />
      <TextContainer>
        <Text variant="h2" weight="semibold">
          {meal.title}
        </Text>
        <Text weight="semibold" numberOfLines={3}>
          {format(meal.start, 'h:mm a')}
        </Text>
      </TextContainer>
      <MealTypePill>
        <Text variant="p2" weight="semibold" color="white">
          {meal.mealType}
        </Text>
      </MealTypePill>
    </Container>
  );
};

const Container = styled.View`
  padding: 0 16px;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  flex: 1;
`;

const Image = styled.Image`
  height: 100%;
  width: 220px;
  border-radius: 20px;
`;

const TextContainer = styled.View`
  gap: 8px;
  flex: 1;
`;

const MealTypePill = styled.View`
  position: absolute;
  top: 10px;
  left: 22px;
  border-radius: 20px;
  background-color: black;
  border-color: white;
  border-width: 1px;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
`;
